import { FaRegUser } from "react-icons/fa";
import { parseTopicFn } from "../../../../services/tinodeConsultationGroupService";

const getOpenedTopics = () => {
  try {
    return new Set(JSON.parse(sessionStorage.getItem("openedTopics") || "[]"));
  } catch {
    return new Set();
  }
};

const markTopicAsOpened = (topicName) => {
  const opened = getOpenedTopics();
  opened.add(topicName);
  sessionStorage.setItem("openedTopics", JSON.stringify([...opened]));
};

const TopicList = ({
  topics,
  selectedTopic,
  onTopicClick,
  unreadCounts = {},
}) => {
  const handleTopicClick = (topicName) => {
    markTopicAsOpened(topicName);
    onTopicClick(topicName);
  };

  return (
    <div style={{ marginTop: "20px" }}>
      {topics.map((topic, index) => {
        const topicName =
          typeof topic === "string"
            ? topic
            : topic.topic || topic.id || topic.name;
        const isSelected = topicName === selectedTopic;
        const unreadCount = Math.max(
          unreadCounts?.[topicName] || 0,
          typeof topic === "object" ? topic.unread || 0 : 0,
        );
        const hasEverBeenOpened = getOpenedTopics().has(topicName);
        const hasRead =
          hasEverBeenOpened ||
          (typeof topic === "object" && (topic.read || 0) > 0);
        const badgeLabel =
          unreadCount <= 0 || isSelected
            ? null
            : !hasRead
              ? "Baru"
              : unreadCount > 99
                ? "99+"
                : String(unreadCount);
        const lastMessage =
          typeof topic === "object" ? topic.lastMessage : null;
        const touched = typeof topic === "object" ? topic.touched : null;
        const updated = typeof topic === "object" ? topic.updated : null;
        const lastActivityTime = touched || updated;
        const isOnline =
          typeof topic === "object" ? topic.online || false : false;

        const meta = parseTopicFn(
          typeof topic === "object" ? topic.public?.fn : "",
        );

        const formatTime = (timestamp) => {
          if (!timestamp) return null;
          const date = new Date(timestamp);
          const now = new Date();
          const isToday = date.toDateString() === now.toDateString();
          if (isToday) {
            return date.toLocaleTimeString("id-ID", {
              hour: "2-digit",
              minute: "2-digit",
              hour12: false,
            });
          } else {
            return date.toLocaleDateString("id-ID", {
              day: "2-digit",
              month: "short",
            });
          }
        };

        return (
          <div
            key={topicName || index}
            className={`p-2 cursor-pointer border rounded-lg mb-2 transition-colors ${
              isSelected
                ? "bg-secondaryActive border-secondary"
                : "bg-white border-slate-200 hover:bg-slate-100"
            }`}
            onClick={() => handleTopicClick(topicName)}
          >
            <div className="flex items-start justify-between gap-2">
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <div className="flex-shrink-0 relative">
                    <div className="w-10 h-10 rounded-full overflow-hidden">
                      {meta.customerProfile === "" ? (
                        <div className="bg-secondary w-full h-full flex items-center justify-center text-white">
                          <FaRegUser size={20} />
                        </div>
                      ) : (
                        <img
                          src={meta.customerProfile}
                          alt=""
                          className="w-full h-full object-cover"
                        />
                      )}
                    </div>
                    {isOnline && (
                      <div className="w-2 h-2 rounded-full z-[99] bg-green-500 absolute bottom-0.5 right-0.5 border border-white" />
                    )}
                  </div>

                  <div className="flex flex-col gap-1">
                    <h1 className="text-slate-700 text-base font-medium line-clamp-1 leading-tight">
                      {meta.customerName || "Unknown User"}
                    </h1>
                    <p className="text-sm text-slate-500">
                      {meta.customerType === 1 ? "Diri sendiri" : "Orang lain"}
                    </p>
                  </div>
                </div>

                {lastMessage && (
                  <p className="text-gray-500 text-sm truncate">
                    {lastMessage}
                  </p>
                )}
              </div>

              <div className="text-right flex-shrink-0 flex flex-col justify-between items-end gap-1">
                {lastActivityTime && (
                  <p className="text-slate-400 font-medium text-sm">
                    {formatTime(lastActivityTime)}
                  </p>
                )}
                {badgeLabel && (
                  <span
                    className={`${badgeLabel === "Baru" ? "font-medium" : "font-semibold"} bg-error min-w-[18px] h-[18px] px-1 rounded-full text-white text-[10px] flex items-center justify-center`}
                  >
                    {badgeLabel}
                  </span>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default TopicList;
